import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import VariationItem from '../../VariationItem';
import * as styles from './style';
import { VARIATIONS_ACTIONS_TYPE } from '../../../helpers/constants';
import withCreateProductAddons from '../../../containers/CreateProductsAddons';
import withVariations from '../../../containers/GlobalVariations';

const onClickProductVariations = ({ type, showModal, removeVariationItem, item }) => {
  switch (type) {
    case VARIATIONS_ACTIONS_TYPE[0].type:
      showModal(type, item);
      break;
    case VARIATIONS_ACTIONS_TYPE[1].type:
      removeVariationItem(item.id);
      break;
    default:
      break;
  }
};

const getClass = item => {
  if (item.isGlobal) {
    return 'global-variation';
  }

  if (item.isCreate) {
    return 'product-variation';
  }

  return '';
};

const getStyle = (style, snapshot, isDraggingOver) => {
  let newStyle = {
    ...style,
    width: 397,
  };

  if (snapshot.isDragging) {
    const { transition } = style;
    const customTransition = 'width 0.33s ease, box-shadow 0.33s ease';

    newStyle = {
      ...newStyle,
      transition: `${customTransition}, ${transition && `${transition}`}`,
      width: isDraggingOver ? 593 : 397,
    };
  }

  return newStyle;
};

const VariationDragDropItem = ({
  item,
  index,
  removeVariationItem,
  setRef,
  showModal,
  showActions,
  isDraggingOver,
}) => (
  <Draggable draggableId={item.id} index={index}>
    {(provided, snapshot) => (
      <styles.StyledVariationItem ref={setRef ? node => setRef(`item_${item.id}`, node) : null}>
        <VariationItem
          className={`product-variation-item ${getClass(item)}`}
          key={item.id}
          variation={item}
          isOpen={false}
          showActions={showActions}
          deleteOnly={item.isGlobal}
          provided={provided}
          isDragging={snapshot.isDragging && !snapshot.isDropAnimating}
          isDraggingOver={isDraggingOver}
          style={getStyle(provided.draggableProps.style, snapshot, isDraggingOver)}
          onClickVariationActions={type => 
            item.isGlobal
              ? removeVariationItem(item.id)
              : onClickProductVariations({ type, showModal, removeVariationItem, item })
          }
        />
      </styles.StyledVariationItem>
    )}
  </Draggable>
);

export default withVariations(withCreateProductAddons(VariationDragDropItem));



// WEBPACK FOOTER //
// ./src/components/VariationDragDrop/VariationDragDropItem/index.js